export default __webpack_public_path__ + "static/media/coach_meter_mg@1x.711dd201.jpg";